// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"ea076988","496":"667c2802","877":"8da08074"}[chunkId] + ".chunk.js";
};